import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PragmaticValidationStatus } from '../../../shared/models/pragmatic-validation-status';
import { Utilities } from '../../../shared/services/utilities';

@Component({
    selector: 'app-pragmatic-grid-column',
    templateUrl: './pragmatic-grid-column.component.html',
    styleUrls: ['./pragmatic-grid-column.component.scss'],
    standalone: false
})

export class PragmaticGridColumnComponent implements OnInit {
    @Input() data!:any;
    @Output() onDownload = new EventEmitter<any>();
    formatOptions: { type: string; format: string; };

    ngOnInit(): void {
        this.formatOptions = { type: 'dateTime', format: Utilities.getLocaleDateString() };
    }

    downloadFile(filePath: string, fileName: string) {
        this.onDownload.emit({filePath, fileName});
    }

    getValidationStatusText(statusCode: number): string {
        switch (statusCode) {
            case PragmaticValidationStatus.Passed:
                return 'Validation Passed';
            case PragmaticValidationStatus.Failed:
                return 'Validation Failed';
            case PragmaticValidationStatus.Error:
                return 'Timeout, please retry';
            default:
                return '';
        }
    }
}
